class UserApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  deleteUser = async ({ id }) => {
    await this.ctx.delete(`/user/${id}`)
  }

  postCahngePd = async (params) => {
    const res = await this.ctx.post('/user/change_profile_data/', params)

    return res.data
  }

  postChangeMailConfirm = async (params) => {
    const res = await this.ctx.post('/user/change_mail_confirm/', params)

    return res.data
  }

  putChangePassword = async (params) => {
    const res = await this.ctx.put('/user/change_password', params)

    return res.data
  }

  patchChangePassword = async (params) => {
    const res = await this.ctx.patch('/user/change_password', params)

    return res.data
  }

  postConfirm = async (params) => {
    const res = await this.ctx.post('/user/confirm/', params)

    return res.data
  }

  getCurrentUser = async () => {
    const res = await this.ctx.get('/user/current/')

    return res.data
  }

  postRepeatOrder = async (orderId) => {
    const res = await this.ctx.post(`/user/orders/${orderId}/repeat_order/`)

    return res.data
  }

  postAddPhoneProfile = async (params) => {
    const res = await this.ctx.post('/user/change_phone/', params)

    return res.data
  }

  postConfirmSmsForPhoneProfile = async (params) => {
    const res = await this.ctx.post('/user/change_phone_confirm/', params)

    return res.data
  }

}

export default UserApi
